'use strict';

import EmptyRouterView from '../../../app/views/EmptyRouterView.vue';

export const leagueManageEventRoutes = [
  {
    path: 'events',
    component: EmptyRouterView,
    children: [
      {
        path: '',
        name: 'league.manage.event.list',
        props: true,
        component: () => import('../views/ManageEventListView.vue'),
      },
    ],
  },
];
